<template>
  <!-- 首页 -->
  <div class="howToObtainAuthorization_component">
      <ul class="menu_top">
          <li v-for="(item,index) in carList" :key="index" ref="menuItem" @click="clickMenuList(index,'menuItem'+index)">
              <div class="topNo1_img"><img v-lazy="item.topimg"></div>
              <div class="topNo2_img">
                  <!-- <img v-lazy="item.numimg"> -->
                  0{{index+1}}
              </div>
              <h4>{{item.title}}</h4>
              <p v-html="item.content"></p>
          </li>
      </ul>
  </div>
</template>

<script>
export default {
  name: 'howToObtainAuthorization_component',
  data () {
    return {
        carList:[
            {title:"注册登录挑选文章",content:"需要您注册账号并登录，在分类导航或搜索页面根据文章标签挑选您所需的文章",topimg:require("@/assets/home/zhucedenglutiaoxuanwenzhang.png"),numimg:require("@/assets/home/weitu.png")},
            {title:"购买授权服务",content:"选定文章后在产品价格选中符合需求的授权服务支付购买，可使用支付宝，微信等支付方式",topimg:require("@/assets/home/goumaifuwushouquan.png"),numimg:require("@/assets/home/weitu.png")},
            {title:"获取授权文章",content:"支付完成后，在转载文章中对挑选要授权的文章进行授权可通过下载获取文章，或通过API控制台电子杂志授权文章",topimg:require("@/assets/home/huoqushouquanwenzhang.png"),numimg:require("@/assets/home/weitu.png")},
            {title:"获取授权书",content:"我们会根据您在账号管理中填写的品牌授权信息，生成电子授权书，您可在已授权中自行下载使用",topimg:require("@/assets/home/huoqushouquanshu.png"),numimg:require("@/assets/home/weitu.png")},
        ]
    }
  },
  methods:{

  },
  mounted(){

  }
}
</script>

<style scoped lang="less">
.howToObtainAuthorization_component{
    padding:60px 0 80px 0;
    .menu_top{
        display: flex;
        justify-content: space-between;
        li{
            width:280px;
            height:280px;
            background:rgba(255,255,255,1);
            box-shadow:0px 6px 12px 0px rgba(0,0,0,0.2);
            border-radius:24px;
            .topNo1_img{
                padding:30px 30px 0 0;
                text-align: right;
                img{
                    height: 38px;
                }
            }
            .topNo2_img{
                padding-left:40px;
                font-size: 40px;
                color:rgba(21,47,106,1);
                line-height:40px;
                font-family:Helvetica;
                img{
                    height: 40px;
                }
            }
            h4{
                font-size:18px;
                // font-family:PingFangSC-Semibold,PingFang SC;
                font-weight:600;
                color:rgba(21,47,106,1);
                line-height:24px;
                padding:10px 40px;
            }
            p{
                font-size:14px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(21,47,106,0.7);
                line-height:24px;
                padding:0px 40px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/home/homeComponents/howToObtainAuthorization.vue